var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-wrapper"},[_c('PageWrapper',[_c('template',{slot:"main"},[_vm._v(" About ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }